/** Версии текстов политик — повышайте при существенном изменении документов. */
export const CONSENT_POLICY_VERSION = {
  cookies: "1",
  privacy: "1",
  newsletter: "1",
} as const;

export type ConsentType = keyof typeof CONSENT_POLICY_VERSION;

export const CONSENT_GUEST_COOKIE = "rs_consent_guest";
export const CONSENT_COOKIES_COOKIE = "rs_consent_cookies";
/** 1 год */
export const CONSENT_COOKIE_MAX_AGE = 60 * 60 * 24 * 365;

export const CONSENT_LINKS = {
  cookies: "/legal/cookies",
  privacy: "/legal/privacy",
  newsletter: "/legal/newsletter",
} as const;
